import { tliveApi } from 'yxt-biz-pc/packages/api';

// 直播列表
export const fetchTliveList = (query, params) => {
  return tliveApi.post('backend/liveroom/component/page', query, { params });
};
